/**
 * PQRBaseMetalTable Component
 * 
 * Reusable component for rendering Base Metals table (QW-403) in PQR PDFs
 * Supports Groove, Overlay, and Tubesheet welding types
 */

import React from "react";
import { getPQRValue } from "./pqrDataUtils";
import { pqrStyles, pqrTableClasses } from "./pqrStyles";

const PQRBaseMetalTable = ({ pdf, type = "Groove", previewUrl1, previewUrl2 }) => {
  const pdfData = pdf[0];
  const isOverlay = type === "Overlay";
  const isTubesheet = type === "Tubesheet";

  const renderOverlayTable = () => (
    <div style={pqrStyles.container}>
      <table id="table" className="pdfwpqTable" style={{ width: "570px" }}>
        <tbody>
          <tr>
            <td style={{ width: "63px" }}></td>
            <th className={pqrTableClasses.border} style={{ width: "55px" }}>Product Form</th>
            <th className={pqrTableClasses.noleft} style={{ width: "95px" }}>Spec.( Type or Grade),UNS#</th>
            <th className={pqrTableClasses.noleft} style={{ width: "29px" }}>P no</th>
            <th className={pqrTableClasses.noleft} style={{ width: "25px" }}>G no</th>
            <th className={pqrTableClasses.noleft} style={{ width: "35px" }}>Size mm</th>
            <th className={pqrTableClasses.noleft} style={{ width: "30px" }}>Sch</th>
            <th className={pqrTableClasses.noleft} style={{ width: "35px" }}>Thk mm</th>
            <th className={pqrTableClasses.noleft} style={{ width: "35px" }}>Dia mm</th>
          </tr>

          <tr>
            <th className={pqrTableClasses.noBotm} style={{ width: "20px" }}></th>
            <td className={pqrTableClasses.right} style={{ textAlign: "left" }}>{getPQRValue(pdfData?.PQR_BM_BM_ProductForm)}</td>
            <td className={pqrTableClasses.right} style={{ textAlign: "left" }}>{getPQRValue(pdfData?.PQR_BM_BM_Spec)}</td>
            <td className={pqrTableClasses.right} style={{ textAlign: "left" }}>{getPQRValue(pdfData?.PQR_BM_BM_Pno)}</td>
            <td className={pqrTableClasses.right} style={{ textAlign: "left" }}>{getPQRValue(pdfData?.PQR_BM_BM_Gno)}</td>
            <td className={pqrTableClasses.right} style={{ textAlign: "left" }}>{getPQRValue(pdfData?.PQR_BM_BM_Size)}</td>
            <td className={pqrTableClasses.right} style={{ textAlign: "left" }}>{getPQRValue(pdfData?.PQR_BM_BM_Sch)}</td>
            <td className={pqrTableClasses.right} style={{ textAlign: "left" }}>{getPQRValue(pdfData?.PQR_BM_BM_Thk)}</td>
            <td className={pqrTableClasses.right} style={{ textAlign: "left" }}>{getPQRValue(pdfData?.PQR_BM_BM_Dia)}</td>
          </tr>

          <tr>
            <th style={{ textAlign: "left", width: "20px" }} className={`${pqrTableClasses.botm} ${pqrTableClasses.rtLft}`}>
              Welded To
            </th>
            <td style={{ textAlign: "left" }} className={`${pqrTableClasses.botm} ${pqrTableClasses.right}`}>{getPQRValue(pdfData?.PQR_BM_WTBM_ProductForm)}</td>
            <td style={{ textAlign: "left" }} className={`${pqrTableClasses.botm} ${pqrTableClasses.right}`}>{getPQRValue(pdfData?.PQR_BM_WTBM_Spec)}</td>
            <td style={{ textAlign: "left" }} className={`${pqrTableClasses.botm} ${pqrTableClasses.right}`}>{getPQRValue(pdfData?.PQR_BM_WTBM_Pno)}</td>
            <td style={{ textAlign: "left" }} className={`${pqrTableClasses.botm} ${pqrTableClasses.right}`}>{getPQRValue(pdfData?.PQR_BM_WTBM_Gno)}</td>
            <td style={{ textAlign: "left" }} className={`${pqrTableClasses.botm} ${pqrTableClasses.right}`}>{getPQRValue(pdfData?.PQR_BM_WTBM_Size)}</td>
            <td style={{ textAlign: "left" }} className={`${pqrTableClasses.botm} ${pqrTableClasses.right}`}>{getPQRValue(pdfData?.PQR_BM_WTBM_Sch)}</td>
            <td style={{ textAlign: "left" }} className={`${pqrTableClasses.botm} ${pqrTableClasses.right}`}>{getPQRValue(pdfData?.PQR_BM_WTBM_Thk)}</td>
            <td style={{ textAlign: "left" }} className={`${pqrTableClasses.botm} ${pqrTableClasses.right}`}>{getPQRValue(pdfData?.PQR_BM_WTBM_Dia)}</td>
          </tr>

          <tr>
            <th className={pqrTableClasses.noTop}>Notes</th>
            <td className={pqrTableClasses.botmrt} style={{ textAlign: "left" }} colSpan={8}>
              {getPQRValue(pdfData?.PQR_BM_BM_Notes)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );

  const renderGrooveTable = () => (
    <div style={pqrStyles.container}>
      <table id="table" className="pdfwpqTable" style={{ width: "570px" }}>
        <tbody>
          <tr>
            <td style={{ width: "63px" }}></td>
            <th className={pqrTableClasses.border} style={{ width: "65px" }}>Product Form</th>
            <th className={pqrTableClasses.noleft} style={{ width: "105px" }}>Spec.( Type or Grade),UNS#</th>
            <th className={pqrTableClasses.noleft} style={{ width: "29px" }}>P no</th>
            <th className={pqrTableClasses.noleft} style={{ width: "25px" }}>G no</th>
            <th className={pqrTableClasses.noleft} style={{ width: "42px" }}>Thk mm</th>
          </tr>

          <tr>
            <th className={pqrTableClasses.noBotm} style={{ width: "20px" }}></th>
            <td className={pqrTableClasses.right} style={{ textAlign: "left" }}>
              {getPQRValue(pdfData?.PQR_BM_BM_ProductForm)}
            </td>
            <td className={pqrTableClasses.right} style={{ textAlign: "left" }}>
              {getPQRValue(pdfData?.PQR_BM_BM_Spec)}
            </td>
            <td className={pqrTableClasses.right} style={{ textAlign: "left" }}>
              {getPQRValue(pdfData?.PQR_BM_BM_Pno)}
            </td>
            <td className={pqrTableClasses.right} style={{ textAlign: "left" }}>
              {getPQRValue(pdfData?.PQR_BM_BM_Gno)}
            </td>
            <td className={pqrTableClasses.right} style={{ textAlign: "left" }}>
              {getPQRValue(pdfData?.PQR_BM_BM_Thk)}
            </td>
          </tr>

          <tr>
            <th style={{ textAlign: "left", width: "20px" }} className={`${pqrTableClasses.botm} ${pqrTableClasses.rtLft}`}>
              Welded To
            </th>
            <td style={{ textAlign: "left" }} className={`${pqrTableClasses.botm} ${pqrTableClasses.right}`}>
              {getPQRValue(pdfData?.PQR_BM_WTBM_ProductForm)}
            </td>
            <td style={{ textAlign: "left" }} className={`${pqrTableClasses.botm} ${pqrTableClasses.right}`}>
              {getPQRValue(pdfData?.PQR_BM_WTBM_Spec)}
            </td>
            <td style={{ textAlign: "left" }} className={`${pqrTableClasses.botm} ${pqrTableClasses.right}`}>
              {getPQRValue(pdfData?.PQR_BM_WTBM_Pno)}
            </td>
            <td style={{ textAlign: "left" }} className={`${pqrTableClasses.botm} ${pqrTableClasses.right}`}>
              {getPQRValue(pdfData?.PQR_BM_WTBM_Gno)}
            </td>
            <td style={{ textAlign: "left" }} className={`${pqrTableClasses.botm} ${pqrTableClasses.right}`}>
              {getPQRValue(pdfData?.PQR_BM_WTBM_Thk)}
            </td>
          </tr>

          <tr>
            <th className={pqrTableClasses.noTop}>Notes</th>
            <td className={pqrTableClasses.botmrt} style={{ textAlign: "left" }} colSpan={5}>
              {getPQRValue(pdfData?.PQR_BM_BM_Notes)}
            </td>
          </tr>
          <tr>
            <th className={pqrTableClasses.noTop}>Heat Treatment Condition</th>
            <td className={pqrTableClasses.botmrt} style={{ textAlign: "left" }} colSpan={5}>
              {getPQRValue(pdfData?.PQR_BM_HeatTreatmentCondition)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );

  const renderTubesheetTable = () => (
    <div style={pqrStyles.container}>
      <table id="table" className="PQRTable2">
        <tbody>
          <tr>
            <td style={{ width: "53px" }}></td>
            <th className={pqrTableClasses.border} style={{ textAlign: "center", width: "33px" }}>Product Form</th>
            <th className={pqrTableClasses.noleft} style={{ textAlign: "center", width: "93px" }}>Spec.( Type or Grade),UNS#</th>
            <th className={pqrTableClasses.noleft} style={{ textAlign: "center", width: "23px" }}>P No.</th>
            <th className={pqrTableClasses.noleft} style={{ textAlign: "center", width: "23px" }}>G No</th>
            <th className={pqrTableClasses.noleft} style={{ textAlign: "center", width: "23px" }}>Thk.mm</th>
            <th className={pqrTableClasses.noleft} style={{ textAlign: "center", width: "23px" }}>Dia.mm</th>
          </tr>
          <tr>
            <th className={pqrTableClasses.noBotm} style={{ width: "63px" }}></th>
            <td className={pqrTableClasses.right}>{getPQRValue(pdfData?.PQR_BM_BM_ProductForm, "-")}</td>
            <td className={pqrTableClasses.right}>{getPQRValue(pdfData?.PQR_BM_BM_Spec, "-")}</td>
            <td className={pqrTableClasses.right}>{getPQRValue(pdfData?.PQR_BM_BM_Pno, "-")}</td>
            <td className={pqrTableClasses.right}>{getPQRValue(pdfData?.PQR_BM_BM_Gno, "-")}</td>
            <td className={pqrTableClasses.right}>{getPQRValue(pdfData?.PQR_BM_BM_Thk, "-")}</td>
            <td className={pqrTableClasses.right}>{getPQRValue(pdfData?.PQR_BM_BM_Dia, "-")}</td>
          </tr>
          <tr>
            <th className={`${pqrTableClasses.botm} ${pqrTableClasses.rtLft}`} style={{ width: "63px" }}>Welded To</th>
            <td className={pqrTableClasses.botmrt}>{getPQRValue(pdfData?.PQR_BM_WTBM_ProductForm, "-")}</td>
            <td className={pqrTableClasses.botmrt}>{getPQRValue(pdfData?.PQR_BM_WTBM_Spec, "-")}</td>
            <td className={pqrTableClasses.botmrt}>{getPQRValue(pdfData?.PQR_BM_WTBM_Pno, "-")}</td>
            <td className={pqrTableClasses.botmrt}>{getPQRValue(pdfData?.PQR_BM_WTBM_Gno, "-")}</td>
            <td className={pqrTableClasses.botmrt}>{getPQRValue(pdfData?.PQR_BM_WTBM_Thk, "-")}</td>
            <td className={`${pqrTableClasses.botm} ${pqrTableClasses.right}`}>{getPQRValue(pdfData?.PQR_BM_WTBM_Dia, "-")}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );

  return (
    <>
      <div style={pqrStyles.group}>
        <div className="PQRbasemetal">BASE METALS (QW- 403)</div>
      </div>
      <div style={pqrStyles.group}>
        <div className="PQRbasemetal" style={{ width: "31%" }}></div>
      </div>
      {isTubesheet ? renderTubesheetTable() : isOverlay ? renderOverlayTable() : renderGrooveTable()}
    </>
  );
};

export default PQRBaseMetalTable;